import { Container } from 'pixi.js';
import { addResizeListener } from './display';
import { App } from './pixiRenderer';
import { EventName } from 'game/events/eventsName';
import { GameEvent } from 'game/events/gameEvent';
export function addToLevel(container: Container) {
    GameEvent.emit(EventName.ADD_TO_LEVEL, container);
}
export function addToUI(container: Container) {
    GameEvent.emit(EventName.ADD_TO_UI, container);
}
export function addToOverlay(container: Container) {
    GameEvent.emit(EventName.ADD_TO_OVERLAY, container);
}
export function addToBackground(container: Container) {
    GameEvent.emit(EventName.ADD_TO_BACKGROUND, container);
}
export function fadeUI(alpha: number, duration = 0.5) {
    GameEvent.emit(EventName.FADE_UI, { alpha, duration });
}

export class Playable2DRootContainer {
    levelContainer: Container;
    uiContainer: Container;
    bgContainer: Container;
    overlayContainer: Container;

    constructor(configSetting = {}) {
        App.initApp(configSetting);
        this.levelContainer = new Container();
        this.uiContainer = new Container();
        this.bgContainer = new Container();
        this.overlayContainer = new Container();
        this.uiContainer.sortableChildren = true;
        this.levelContainer.sortableChildren = true;
        this.bgContainer.sortableChildren = true;
        this.overlayContainer.sortableChildren = true;

        this.resizeLevel = this.resizeLevel.bind(this);
        this.addToLevel = this.addToLevel.bind(this);
        this.addToUI = this.addToUI.bind(this);
        this.addToBackground = this.addToBackground.bind(this);
        this.addToOverlay = this.addToOverlay.bind(this);

        this.showGame = this.showGame.bind(this);
        this.hideGame = this.hideGame.bind(this);
        this.hideUI = this.hideUI.bind(this);
        this.showUI = this.showUI.bind(this);

        App.stageContainer.addChild(this.bgContainer);
        App.stageContainer.addChild(this.levelContainer);
        App.stageContainer.addChild(this.uiContainer);
        App.stageContainer.addChild(this.overlayContainer);

        addResizeListener(this.resizeLevel, 'resizeLevel');
        GameEvent.add(EventName.ADD_TO_LEVEL, this.addToLevel);
        GameEvent.add(EventName.ADD_TO_UI, this.addToUI);
        GameEvent.add(EventName.ADD_TO_BACKGROUND, this.addToBackground);
        GameEvent.add(EventName.ADD_TO_OVERLAY, this.addToOverlay);
        GameEvent.add(EventName.HIDE_UI, this.hideUI);
        GameEvent.add(EventName.SHOW_UI, this.showUI);
        GameEvent.add(EventName.HIDE_GAME, this.hideGame);
        GameEvent.add(EventName.SHOW_GAME, this.showGame);
    }
    showGame() {
        this.levelContainer.visible = true;
    }
    hideGame() {
        this.levelContainer.visible = false;
    }
    hideUI() {
        this.uiContainer.visible = false;
    }
    showUI() {
        this.uiContainer.visible = true;
    }

    addToLevel(container: Container) {
        this.levelContainer.addChild(container);
    }
    addToUI(container: Container) {
        this.uiContainer.addChild(container);
    }
    addToBackground(container: Container) {
        this.bgContainer.addChild(container);
    }
    addToOverlay(container: Container) {
        this.overlayContainer.addChild(container);
    }

    resizeLevel(width: number, height: number) {
        this.levelContainer.position.x = width / 2;
        this.levelContainer.position.y = height / 2;

        this.bgContainer.position.x = width / 2;
        this.bgContainer.position.y = height / 2;

        this.overlayContainer.position.x = width / 2;
        this.overlayContainer.position.y = height / 2;
    }
}
